import BusinessSettings from './BusinessSettings';

export default BusinessSettings;
